<div class="p-2">
    {{controlTemplate?.settings?.label}}
</div>